import { useState, useCallback } from "react";
import { convertTextToHtml } from "../utils/textProcessing";
import { extractPlainText } from "../utils/exportUtils";

/**
 * useEditor - Custom hook for managing editor modal state and actions
 * @returns {Object} { isOpen, title, content, meta, openEditor, closeEditor, saveEditor, updateContent }
 */
export function useEditor() {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [meta, setMeta] = useState({ type: null, model: null });

  const openEditor = useCallback((type, editorTitle, value, editorMeta = {}) => {
    setMeta({ type, ...editorMeta });
    setTitle(editorTitle);
    const isHtml = value && (value.includes('<p>') || value.includes('<h') || value.includes('<ol>') || value.includes('<ul>') || value.includes('<strong>') || value.includes('<li>'));
    const htmlContent = isHtml ? value : convertTextToHtml(value);
    console.log('[useEditor] Opening editor:', {
      type,
      editorTitle,
      isHtml,
      valuePreview: value?.substring(0, 100),
      htmlPreview: htmlContent?.substring(0, 150)
    });
    setContent(htmlContent);
    setIsOpen(true);
  }, []);

  const closeEditor = useCallback(() => {
    setIsOpen(false);
  }, []);

  const saveEditor = useCallback(() => {
    const plainText = extractPlainText(content);
    return { plainText, htmlContent: content, meta };
  }, [content, meta]);

  const updateContent = useCallback((newContent) => {
    setContent(newContent);
  }, []);

  return {
    isOpen,
    title,
    content,
    meta,
    openEditor,
    closeEditor,
    saveEditor,
    updateContent
  };
}

